import { publicApiClient } from '@/lib/api/client';
import type { 
  FetchPublicMenuItemSchedulesRequestQuery, 
  MenuItemSchedulesApiResponse 
} from '../types/menuItemTypes';

/**
 * Service for fetching menu items and their schedules.
 */
export const menuService = {
  /**
   * Fetches all publicly available menu item schedules for a specific event booking category.
   * GET /api/public/v1/menu-item/event-booking-category/:eventBookingCategoryID/schedules
   * 
   * @param eventBookingCategoryId - The ID of the event booking category
   * @param query - Optional filtering and pagination parameters
   * @returns Promise containing the list of menu item schedules
   */
  fetchPublicMenuItemSchedules: async (
    eventBookingCategoryId: string,
    query?: FetchPublicMenuItemSchedulesRequestQuery
  ): Promise<MenuItemSchedulesApiResponse> => {
    const response = await publicApiClient.get<MenuItemSchedulesApiResponse>(
      `/api/public/v1/menu-item/event-booking-category/${eventBookingCategoryId}/schedules`,
      { params: query } as any
    );
    return response;
  },
};
